<div class="main-content">
  <div class="container-fluid">

    <div class="admin-page-header" *ngIf="exportAuthorized()">
      <div class="header-actions">
        <button (click)="exportCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> Services CSV
        </button>
        <button (click)="exportReportsCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> Mentoring Reports CSV
        </button>
        <button (click)="exportPssReportsCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> PSS Reports CSV
        </button>
        <button (click)="exportAdvicesCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> Advices CSV
        </button>
      </div>
    </div>

    <div class="services-table-wrap">
      <loader *ngIf="loading"></loader>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th *ngFor="let cell of headerRow" (click)="sortCell(cell)" class="sortable">
                {{ cell }}
                <i class="fa fa-sort-asc"  *ngIf="sortSelected == cell && sortDirection == 'ASC'"></i>
                <i class="fa fa-sort-desc" *ngIf="sortSelected == cell && sortDirection == 'DESC'"></i>
                <i class="fa fa-sort sort-neutral" *ngIf="sortSelected != cell"></i>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of associations">
              <td>{{ row['ID'] }}</td>
              <td>
                <a class="row-link" (click)="openNewTab('/#/project/'+row['project_id'])">{{ row['Project'] }}</a>
              </td>
              <td class="d-none d-md-table-cell">{{ row['Submission date UTC'] }}</td>
              <td>
                <a class="row-link" (click)="openNewTab('/#/epe/'+row['epe_id'])">{{ row['EPE'] }}</a>
              </td>
              <td class="d-none d-md-table-cell">{{ row['Status'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Approv date UTC'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 1 set/done'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 1 date'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 2 set/done'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 2 date'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 3 set/done'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Meeting 3 date'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Advice'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Final meeting set/done'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Final meeting date'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Report Submission'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Service complete'] }}</td>
              <td>
                <button (click)="goToService(row['project_id'], row['epe_id'])"
                        class="btn btn-sm btn-primary">
                  Go to service <i class="fa fa-arrow-right"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
